module.exports = __webpack_public_path__ + "img/crFTD.82345a31.svg";